import type { ChartConfig } from "@/components/ui/chart";
import { MULTIPLE_COLORS, YES_NO_COLORS } from "@roman/shared/constants/predictionChart";
import type { Choice } from "./choiceSelection";

/**
 * Create chart configuration for selected lines with fixed colors based on choice order
 */
export const createChartConfig = (allChoices: Choice[]): ChartConfig => {
  const config: ChartConfig = {};

  // Determine color palette based on total number of choices
  let colors: string[];
  if (allChoices.length === 2) {
    colors = YES_NO_COLORS;
  } else {
    colors = MULTIPLE_COLORS;
  }

  // Assign fixed colors based on sorted choice order
  allChoices.forEach((choice, index) => {
    const colorIndex = allChoices.length <= 20 ? index : index % colors.length;
    const color = colors[colorIndex];
    config[choice.id] = {
      label: choice.name,
      color: color,
    };
  });

  return config;
};
